import { Popper as MuiPopper, ClickAwayListener } from "@mui/material";
import { useTranslation } from "react-i18next";
import EmojiPicker from 'emoji-picker-react';

const EmojiPickerPopper = ({ preview, open, anchorEl, onEmojiClick, onClose }) => {
    const { t } = useTranslation("fragments");

    if (!open || !anchorEl) return null;

    return (
        <MuiPopper
            open={open}
            anchorEl={anchorEl}
            placement="top-start"
            className="emoji-picker-popper"
            modifiers={[
                {
                    name: 'offset',
                    options: {
                        offset: [0, 8],
                    },
                },
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: 'viewport',
                        padding: 16,
                        altAxis: true,
                        altBoundary: true,
                        tether: true,
                        tetherOffset: 0,
                    },
                },
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: ['top-start', 'top', 'top-end', 'bottom-start', 'bottom', 'bottom-end', 'left-start', 'left', 'right-start', 'right'],
                        altBoundary: true,
                        rootBoundary: 'viewport',
                    },
                },
                {
                    name: 'shift',
                    options: {
                        padding: 16,
                        altAxis: true,
                    },
                },
            ]}
            style={{ zIndex: 1300 }}
        >
            <ClickAwayListener onClickAway={onClose}>
                <div style={{
                    maxWidth: 'min(350px, calc(100vw - 32px))',
                    maxHeight: 'min(400px, calc(100vh - 32px))',
                    overflow: 'hidden',
                    borderRadius: '8px',
                }}>
                    <EmojiPicker
                        className="emoji-picker"
                        onEmojiClick={onEmojiClick}
                        width={350}
                        height={400}
                        reactionsDefaultOpen={preview}
                        previewConfig={{
                            showPreview: false
                        }}
                        emojStyle="facebook"
                        searchPlaceHolder={t("input.emoji.searchPlaceholder")}
                        theme={window.appearenceMode}
                        autoFocusSearch={false}
                        categories={[
                            {
                                category: 'suggested',
                                name: t('input.emoji.categories.suggested')
                            },
                            {
                                category: 'smileys_people',
                                name: t('input.emoji.categories.smileysPeople')
                            },
                            {
                                category: 'animals_nature',
                                name: t('input.emoji.categories.animalsNature')
                            },
                            {
                                category: 'food_drink',
                                name: t('input.emoji.categories.foodDrink')
                            },
                            {
                                category: 'travel_places',
                                name: t('input.emoji.categories.travelPlaces')
                            },
                            {
                                category: 'activities',
                                name: t('input.emoji.categories.activities')
                            },
                            {
                                category: 'objects',
                                name: t('input.emoji.categories.objects')
                            },
                            {
                                category: 'symbols',
                                name: t('input.emoji.categories.symbols')
                            },
                            {
                                category: 'flags',
                                name: t('input.emoji.categories.flags')
                            }
                        ]}
                    />
                </div>
            </ClickAwayListener>
        </MuiPopper>
    );
};

export default EmojiPickerPopper;
